import React from "react";

const legendData = [
  { color: "var(--c-secondary)", text: "CAEMZ" },
  { color: "var(--c-purple)", text: "Monasterio de la Resurrección de la Orden de Canonesas Regulares de Santo Sepulcro." },
];

const Legend = () => {
  return (
    <div className="m-legend">
      {legendData.map((item, index) => (
        <div key={index} className="legend-item">
          <div className="legend-color" style={{ backgroundColor: item.color }}></div>
          <div className="legend-text">{item.text}</div>
        </div>
      ))}
    </div>
  );
};

export default Legend;
